import React from 'react';
import { planCableListPages, planVlanListPages, renderCableListPage, renderVlanListPage } from '@/lib/svgExport';
import { useStore } from '@/state/store';

// Auto pages (cable list / VLAN list) can expand into MULTIPLE A3 sheets
// when there are many connections/VLANs. We plan the sheets, number them within
// the overall document total ("SHEET X / Y"), and stack them vertically in a
// single scrollable column so the whole content is reachable on screen. Each
// sheet keeps its A3 aspect ratio (width-fit). The .drawio export stays
// single-page (handled elsewhere) — draw.io tiles long pages natively.
export const AutoView = ({ kind }) => {
  const doc = useStore((s) => s.doc);
  const lang = useStore((s) => s.language);

  const base = doc.pages.length;
  const cablePlan = planCableListPages(doc, lang);
  const vlanPlan = planVlanListPages(doc, lang);
  const total = base + cablePlan.length + vlanPlan.length;

  let svgs;
  if (kind === 'cablelist') {
    svgs = cablePlan.map((pg, i) => renderCableListPage(pg, doc, lang, { index: base + 1 + i, total }));
  } else {
    const start = base + cablePlan.length;
    svgs = vlanPlan.map((pg, i) => renderVlanListPage(pg, doc, lang, { index: start + 1 + i, total }));
  }

  return (
    <div
      className="h-full w-full overflow-auto bg-[#e9e9e4] p-4"
      data-testid={kind === 'cablelist' ? 'auto-view-cablelist' : 'auto-view-vlanlist'}
    >
      <div className="mx-auto flex w-full max-w-[1180px] flex-col items-center gap-4">
        {svgs.map((svg, i) => (
          <div
            key={`${kind}-sheet-${i}`}
            className="w-full [&>svg]:h-auto [&>svg]:w-full [&>svg]:drop-shadow-xl"
            data-testid={`auto-sheet-${i + 1}`}
            dangerouslySetInnerHTML={{ __html: svg }}
          />
        ))}
      </div>
    </div>
  );
};
